import { FeatureEnum } from "./../core/properties/feature.enum";
import { FeatureToggleService } from "./../core/services/feature-toggle.service";
import { Component, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { ProfileModelService, Role } from "../profile/profile-model.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  user: string;
  isAuthenticated = true;
  isLinearPlayoutToggleEnabled = false;
  isSubscriptionsToggleEnabled = false;
  newRelic = {
    label: "Silence Detection Dashboard",
    icon: "get_app",
    link: "https://onenr.io/037jb23M3jy",
    queryParam: {},
    target: "_blank",
  };
  navLinks = [
    {
      label: "Manage",
      icon: "mic",
      link: "/manage",
      queryParam: {},
    },
    {
      label: "Listen by Station",
      icon: "mic",
      link: "/home",
      queryParam: {},
    },
    {
      label: "Linear Playout",
      icon: "mic",
      link: "/linear-playout",
      queryParam: {},
    },

    {
      label: "Downloads",
      icon: "get_app",
      link: "/downloads",
      queryParam: {},
    },
    {
      label: "Subscriptions",
      icon: "subscriptions",
      link: "/subscriptions",
      queryParam: {},
    },
  ];

  constructor(
    private authService: MsalService,
    private profileModelService: ProfileModelService,
    private featureToggleService: FeatureToggleService,
  ) {}

  ngOnInit() {
    this.isLinearPlayoutToggleEnabled = this.featureToggleService.isEnabled(
      FeatureEnum.isLinearPlayoutToggleEnabled,
    );
    this.isSubscriptionsToggleEnabled = this.featureToggleService.isEnabled(
      FeatureEnum.isSubscriptionsToggleEnabled,
    );

    // Check initial profile state
    this.updateNavLinks();

    // Subscribe to profile updates
    this.profileModelService.profileUpdated.subscribe((update) => {
      console.log(
        "Profile updated event fired. Current profile:",
        this.profileModelService.getProfile(),
      );
      this.updateNavLinks();
    });
  }

  private updateNavLinks() {
    const isAdmin = this.isAdminUser();
    const hasManageTab = this.navLinks.some((link) => link.label === "Manage");

    console.log(
      "updateNavLinks - isAdmin:",
      isAdmin,
      "hasManageTab:",
      hasManageTab,
      "profile:",
      this.profileModelService.getProfile(),
    );

    // Handle Manage tab visibility
    if (isAdmin && !hasManageTab) {
      // Add Manage tab back if admin and it's missing
      this.navLinks.unshift({
        label: "Manage",
        icon: "mic",
        link: "/manage",
        queryParam: {},
      });
      console.log("Added Manage tab for admin user");
    } else if (!isAdmin && hasManageTab) {
      // Remove Manage tab if not admin
      this.navLinks = this.navLinks.filter((link) => link.label !== "Manage");
      console.log("Removed Manage tab for non-admin user");
    }

    if (!this.isLinearPlayoutToggleEnabled) {
      this.navLinks = this.navLinks.filter(
        (link) => link.label !== "Linear Playout",
      );
    }
    if (!this.isSubscriptionsToggleEnabled) {
      this.navLinks = this.navLinks.filter(
        (link) => link.label !== "Subscriptions",
      );
    }
  }

  isAdminUser() {
    const profile = this.profileModelService.getProfile();
    console.log("isAdminUser check - profile:", profile);
    if (profile && profile.role && profile.role.profileAccess) {
      const isAdmin = profile.role.profileAccess === Role.ADMIN;
      console.log(
        "isAdminUser - profileAccess value:",
        profile.role.profileAccess,
        "isAdmin result:",
        isAdmin,
        "Role.ADMIN constant:",
        Role.ADMIN,
      );
      return isAdmin;
    }
    return false;
  }

  logout() {
    this.authService.logout();
  }

  userLogged() {
    return this.authService.instance?.getAllAccounts()[0] != null
      ? this.authService.instance.getAllAccounts()[0].name
      : "";
  }
}
